/**
 * Shim for @apollo/client to provide a default export for cjs interop.
 * Apollo Client v4 has no default export; sku's cjsInterop expects one.
 * Use resolve.alias to redirect @apollo/client to this file for SSR.
 */
export * from '@apollo/client/core';
export { useQuery, useMutation } from '@apollo/client/react';
export { ApolloClient as default } from '@apollo/client/core';
